import React, { memo } from 'react';

const LogoutIcon = (props) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M11.9992 9H19.9492C19.4492 3.947 15.1852 0 9.99922 0C4.47622 0 -0.000782013 4.477 -0.000782013 10C-0.000782013 15.523 4.47622 20 9.99922 20C15.1842 20 19.4482 16.053 19.9492 11H11.9992V14L6.99922 10L11.9992 6V9Z"
            fill="currentColor" />
    </svg>

);

export default memo(LogoutIcon);
